export default function createClearStorePlugin() {
  return store => {
    store.subscribe((mutation, state) => {
      if (mutation.type === 'contract/SET_ACTIVE_CONTRACT') {
        // Список всех модулей, которые нужно очистить
        const modulesToClear = [
          'contractDatabase',
          'contractHistory',
          'contractCustomerDatabase',
          'contractCustomerStorage',
          'contractCron',
          'contractSite',
          'contractStorage',
          'contractFileManager'
        ];

        modulesToClear.forEach(module => {
          if (store.state[module]) {
            store.commit(`${module}/CLEAR_STORE_DATA`);
          }
        });
      }
    });
  };
}